export default __webpack_public_path__ + "8816aed3f57e35cfd7205a438b7c240b.svg";